import { forwardRef, type Ref, type SVGProps } from "react";

function SvgChatWithGradient(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="176"
      height="120"
      fill="none"
      viewBox="0 0 176 120"
      {...props}
    >
      <path
        d="M57.4729 90.3815L52.2435 87.4399L57.4729 90.3815ZM89.9647 100.956L89.6951 94.962L89.9647 100.956ZM125 58C125 77.8664 109.34 94.0785 89.6951 94.962L90.2342 106.95C116.262 105.779 137 84.3132 137 58H125ZM88 21C108.435 21 125 37.5655 125 58H137C137 30.938 115.062 9 88 9V21ZM51 58C51 37.5655 67.5655 21 88 21V9C60.938 9 39 30.938 39 58H51ZM61.4404 83.7602C54.9722 77.0928 51 68.0164 51 58H39C39 71.2597 44.2748 83.2998 52.8274 92.1159L61.4404 83.7602ZM52.2435 87.4399L47.9471 95.0779L58.406 100.961L62.7024 93.3231L52.2435 87.4399ZM54.9197 107H88V95H54.9197V107ZM88 107H89.9538V95H88V107ZM89.9538 107C96.1895 107 98.3015 98.677 92.8201 95.7039L87.0986 106.252C81.6387 103.291 83.7424 95 89.9538 95V107ZM47.9471 95.0779C44.9474 100.411 48.8011 107 54.9197 107V95C57.979 95 59.9059 98.2946 58.406 100.961L47.9471 95.0779ZM52.8274 92.1159C51.7016 90.9554 51.3264 89.0702 52.2435 87.4399L62.7024 93.3231C64.5138 90.1026 63.8365 86.2302 61.4404 83.7602L52.8274 92.1159ZM89.6951 94.962C83.9329 95.2211 81.459 103.193 87.0986 106.252L92.8201 95.7039C98.4389 98.7516 95.9726 106.692 90.2342 106.95L89.6951 94.962Z"
        fill="url(#paint0_linear_4496_13348)"
      />
      <circle cx="73" cy="58" r="4" stroke="#0C1C43" />
      <circle cx="88" cy="58" r="4" stroke="#0C1C43" />
      <circle cx="103" cy="58" r="4" stroke="#0C1C43" />
      <defs>
        <linearGradient
          id="paint0_linear_4496_13348"
          x1="87.5"
          y1="4.5"
          x2="87.5"
          y2="110.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7DDFF" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChatWithGradient);
export default ForwardRef;
